// Perry app
export const loginEndpoint = 'auth/login';
export const logOutEndpoint = 'auth/logout';
export const googleSsoEndpoint = 'auth/googleSso';
